// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9e4be5c9","327":"058bf12d","348":"89c74708","580":"f9a864e0","833":"b549d6d8","977":"877a214d","988":"45c35fcc"}[chunkId] + ".chunk.js";
};